import { globalOptions } from 'Dictionaries/imports/importOptionsDictionary.js';

const opts = _.merge(
    {
        parameters: {},
        identifiers: {
            'product-variation': {
                title: window.i18n.__('Critère de comparaison pour les déclinaisons produits'),
                multiple: false,
                choices: [
                    {
                        value: 'variation_reference',
                        label: window.i18n.__('Référence'),
                        description: window.i18n.__(
                            'Référence ou code de la déclinaison produit unique dans le catalogue',
                        ),
                    },
                    {
                        value: 'variation_id',
                        label: window.i18n.__('Identifiant déclinaison produit'),
                        description: window.i18n.__(
                            'Récupéré depuis un export Sellsy ou depuis le catalogue',
                        ),
                    },
                ],
            },
            product: {
                title: window.i18n.__('Critère de comparaison pour les produits'),
                multiple: false,
                choices: [
                    {
                        value: 'product_reference',
                        label: window.i18n.__('Référence'),
                        description: window.i18n.__(
                            'Référence ou code du produit unique dans le catalogue',
                        ),
                    },
                    {
                        value: 'product_id',
                        label: window.i18n.__('Identifiant produit'),
                        description: window.i18n.__(
                            'Récupéré depuis un export Sellsy ou depuis le catalogue',
                        ),
                    },
                ],
            },
        },
    },
    globalOptions,
);

delete opts.parameters.update.options.overwrite_tags;

export const options = opts;

export const defaultOptions = {
    identifiers: {
        'product-variation': ['variation_reference'],
        product: ['product_reference'],
    },
};
